export default __webpack_public_path__ + "static/media/file-check-outline.a092ba89.svg";